import { AddIcon, ChevronDownIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { Box, Collapse, Stack, Typography, useTheme } from '@mui/material';
import { MouseEvent, ReactNode, useState } from 'react';

type DatasetDetailsAccordionProps = {
  title: string;
  count?: number;
  startOpen?: boolean;
  onCreate?: VoidFunction;
  details: ReactNode;
  disabled?: boolean;
};

export const DatasetDetailsAccordion = ({
  title,
  count,
  startOpen = false,
  onCreate,
  details,
  disabled = false,
}: DatasetDetailsAccordionProps) => {
  const { palette } = useTheme();
  const [shouldExpand, setShouldExpand] = useState<boolean>(startOpen);
  const handleCollapseChange = () => setShouldExpand(!shouldExpand);
  const onCreateClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (onCreate) {
      onCreate();
    }
  };
  return (
    <Stack sx={{ background: 'none', pr: 2, width: '100%' }}>
      <Group
        onClick={disabled ? undefined : handleCollapseChange}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          '&:hover': { cursor: disabled ? 'default' : 'pointer' },
        }}
      >
        <Group gap={1} alignItems="center">
          <Typography
            variant="body1"
            sx={{ color: disabled ? palette.input.label.disabled : undefined }}
          >
            {title}
          </Typography>
          {count !== null && count !== undefined && (
            <Typography variant="body1">({count})</Typography>
          )}
        </Group>
        <Group gap={3} alignItems="center">
          {onCreate && <IconButton onClick={onCreateClick} Icon={AddIcon} />}
          <ChevronDownIcon
            style={{
              transition: 'all 0.2s',
              transform: !shouldExpand ? 'rotate(0deg)' : 'rotate(180deg)',
            }}
          />
        </Group>
      </Group>
      <Collapse in={shouldExpand}>
        <Box sx={{ pt: 3, width: '100%' }}>{details}</Box>
      </Collapse>
    </Stack>
  );
};
